import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSupportedRoleEntitlementsLogsActions} from 'src/openapi/admin/apis/EntitlementLogDictionariesApi';
import {useAppDispatch} from 'src/store/hooks';

export const useGetEntitlementRoleActionTypeDictionary = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getSupportedRoleEntitlementsLogsActions(),
    ), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
